import { grafanaAlertManipulator, CONDITION_REF_ID } from '../alert/grafana-alert.manipulator';
export class GrafanaProvisionedAlertRule {
    title;
    condition;
    data;
    noDataState;
    execErrState;
    for;
    id;
    uid;
    updated;
    orgID;
    folderUID;
    ruleGroup;
    isPaused = false;
    constructor(alert) {
        if (!alert)
            return;
        this.uid = alert.uid || (alert.id ? `logzio-alert-${alert.id}` : undefined);
        this.folderUID = 'logzio-alerts-folder';
        this.ruleGroup = 'Logzio Unified Alerts';
        this.title = alert.title || 'Untitled Alert';
        this.condition = CONDITION_REF_ID;
        this.data = grafanaAlertManipulator.buildDataArray(alert);
        this.noDataState = 'NoData';
        this.execErrState = 'OK';
        this.isPaused = !alert.isEnabled;
        this.for = `${alert.searchTimeFrameMinutes}m`;
        this.annotations = grafanaAlertManipulator.buildAnnotations(alert);
        this.labels = { logzio_alert: 'notify' };
    }
    labels = {
        logzio_alert: 'notify',
    };
    annotations = {};
}
//# sourceMappingURL=grafana-alert-provisioning.js.map